import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

import { TStudentMenuDatasource } from '../datasource/student_menu_datasource';
import { StudentMenu } from '../builders/student_menu_builder';

angular
  .module('lib')
  .factory(
    'loadStudentMenuCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngStudentMenuDatasource: TStudentMenuDatasource,
      log: any
    ): ICommand => {
      return defineCommandORM('loadStudentMenuCommand', (deferred: ng.IDeferred<IQuery[]>) => {
        const pullData = new Promise((resolve) =>
          $http({
            method: 'GET',
            url: `config/studentmenuitems/`
          }).then(resolve)
        );
        pullData
          .then(({ data }) => {
            data.data.forEach((o: StudentMenu) => {
              o.id = o.nk;
              o.icon_theme = o.icon_color;
              o.title = o.name;
              o.release_status = o.is_in_beta ? 'beta' : o.is_new ? 'new' : '';
              o.uri = o.url ? o.url : '';
              o.target = o.url ? '_blank' : '_self';
            });
            const hiddenMenuNks = ['PLANNER', 'SCHEDULER'];
            const menuItems = data.data.filter(({ nk }: { nk: string}) => !hiddenMenuNks.includes(nk));

            ngStudentMenuDatasource.clear().write(menuItems);
            deferred.resolve();
          })
          .catch((e: any) => {
            log.issue('Failed to get custom menu');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/lib/responsive_navigation/commands/load_student_menu_command.ts